type FormatOptions = {
  compactDisplay?: 'short' | 'long';
  locale?: 'en-US';
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

function getOrdinalName(number: number) {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const mod100 = number % 100;
  if (mod100 >= 11 && mod100 <= 13) {
    return number + 'th';
  } else {
    const mod10 = number % 10;
    const suffix = suffixes[mod10] || suffixes[0];
    return number + suffix;
  }
}

const format = (amount: number | string, opts?: FormatOptions) => {
  const defaultFractionalDigits = String(amount).split('.')[1]?.length ?? 0;
  return new Intl.NumberFormat(opts?.locale ?? 'en-US', {
    compactDisplay: opts?.compactDisplay ?? 'long',
    currency: 'USD',
    maximumFractionDigits: opts?.maximumFractionDigits ?? opts?.minimumFractionDigits ?? defaultFractionalDigits,
    minimumFractionDigits: opts?.minimumFractionDigits ?? 0,
    notation: opts?.compactDisplay === 'short' ? 'compact' : 'standard',
  }).format(Number(amount));
};

export default {
  format,
  getOrdinalName,
};
